module.exports = __webpack_public_path__ + "static/engagementlistitem-3008db1d7b37855344c09d1abd20fff8.png";